<div class="esg-hero" (click)="onCardClick()" #ringContainer>
  <div class="esg-hero__ring-wrapper">
    <svg
      class="esg-hero__ring"
      [attr.width]="size"
      [attr.height]="size"
      [class.esg-hero__ring--animate]="animateRing">

      <circle
        class="esg-hero__track"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        fill="none"
        [attr.stroke-width]="strokeWidth"
        stroke="#f0f0f0"
      />

      <circle
        class="esg-hero__segment esg-hero__segment--environment"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        fill="none"
        [attr.stroke]="colors.environment"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="animateRing ? getSegmentDasharray(score.environment) : getInitialDasharray()"
        [attr.stroke-dashoffset]="getSegmentOffset(0)"
        stroke-linecap="round"
      />

      <circle
        class="esg-hero__segment esg-hero__segment--social"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        fill="none"
        [attr.stroke]="colors.social"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="animateRing ? getSegmentDasharray(score.social) : getInitialDasharray()"
        [attr.stroke-dashoffset]="getSegmentOffset(1)"
        stroke-linecap="round"
      />

      <circle
        class="esg-hero__segment esg-hero__segment--governance"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        fill="none"
        [attr.stroke]="colors.governance"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="animateRing ? getSegmentDasharray(score.governance) : getInitialDasharray()"
        [attr.stroke-dashoffset]="getSegmentOffset(2)"
        stroke-linecap="round"
      />
    </svg>

    <div class="esg-hero__score-display">
      <span class="esg-hero__score-value">{{ displayedScore }}</span>
      <span class="esg-hero__score-label">ESG Score</span>
    </div>
  </div>

  <div class="esg-hero__content">
    <div class="esg-hero__header">
      <span class="esg-hero__eyebrow">Nachhaltigkeit</span>
      <h3 class="esg-hero__title">Dein Business Hub Score</h3>
    </div>

    <div class="esg-hero__chips">
      <button
        type="button"
        class="esg-hero__chip esg-hero__chip--environment"
        (click)="onCategoryClick('environment', $event)"
        [style.background]="chipBackgrounds.environment"
        [style.color]="colors.environment">
        <span class="esg-hero__chip-letter">E</span>
        <span class="esg-hero__chip-score">{{ score.environment }}</span>
      </button>

      <button
        type="button"
        class="esg-hero__chip esg-hero__chip--social"
        (click)="onCategoryClick('social', $event)"
        [style.background]="chipBackgrounds.social"
        [style.color]="colors.social">
        <span class="esg-hero__chip-letter">S</span>
        <span class="esg-hero__chip-score">{{ score.social }}</span>
      </button>

      <button
        type="button"
        class="esg-hero__chip esg-hero__chip--governance"
        (click)="onCategoryClick('governance', $event)"
        [style.background]="chipBackgrounds.governance"
        [style.color]="colors.governance">
        <span class="esg-hero__chip-letter">G</span>
        <span class="esg-hero__chip-score">{{ score.governance }}</span>
      </button>
    </div>
  </div>

  <i class="pi pi-chevron-right esg-hero__arrow"></i>
</div>
